<template>
<div v-if="params.value !== null&&params.value !== undefined" >
    <div @click="openModal" v-if="params.value.data.img.length >0 " >
        <div class="justify-content-center d-flex">
     <b-icon class="mt-1 cursor-pointer"  icon="file-earmark-text" font-scale="3" variant="primary"  ></b-icon></div>
     <b-modal :id="modalId" hide-footer :title="params.value.title" size="lg">
         <b-container fluid>

       
        
         <b-row  class="mx-4">
              <b-col cols="12" v-for="(item, index) in params.value.data.img" :key="index" class="">
                  <img :src="item" alt="" width="450" height="450">
                 
         </b-col>

         </b-row>

         <!-- <b-col cols=12 class="d-flex justify-content-center">
             <b-button variant="primary" @click="closeModal">
                 ยืนยัน
             </b-button>
         </b-col> -->
           </b-container>
        
        
    </b-modal>
    </div>
    <div v-else >
        <p class="text-center">
 -
        </p>
       

    </div>

   
</div>
<div v-else>
    
        <p class="text-center">
 -
        </p>

</div>
    
</template>

<script>
export default {
    data () {
        
        return {
            // title:"ข้อมูลติดต่อ",
            // tel:{
            //     company_name:{
            //         label:"ชื่อบริษัท",
            //         value:"House of Dev Technology Co.Ltd.,"
            //     },
            //     TAX_ID:{
            //         label:"หมายเลขผู้เสียภาษี",
            //         value:"1234"
            //     },
            //     branch_type:{
            //         label:"ประเภทสาขา",
            //         value:"สำนักงานใหญ่"
            //     },
            //     branch_no:{
            //         label:"สาขาเลขที่",
            //         value:"101"

            //     }
            // }

        }
    },mounted () {
    //    this.$root.$emit('bv::show::modal', `1`)
    //    let data_1 = this.params.data.id === 1 ? this.params.value:null
    //    console.log(data_1);
    },
    methods: {
        openModal() {
             this.$root.$emit('bv::show::modal', `i${this.params.data.id}`)
             console.log("this.params",this.params.value);
            
        },
        closeModal(){
            //    this.$root.$emit('bv::hide::modal')

        }
    },computed: {
        modalId() {
            return `i${this.params.data.id}`
        }
    },
}
</script>

<style >
.modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    pointer-events: auto;
    outline: 0;
    top: 200px;
    left: 20%;
}
</style>